const FETCH_PROFILE_LESSON = 'DESK/PROFILE_LESSON/FETCH_PROFILE_LESSON';

export default {
  FETCH_PROFILE_LESSON: FETCH_PROFILE_LESSON,
};
